import { render } from "./ShowExplain.vue?vue&type=template&id=2c517004&scoped=true"
import script from "./ShowExplain.vue?vue&type=script&lang=js"
export * from "./ShowExplain.vue?vue&type=script&lang=js"

import "./ShowExplain.vue?vue&type=style&index=0&id=2c517004&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c517004"]])

export default __exports__